import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
function ComponentMessage({ message, isSuccessful = true, onClose }) {
    const [showMessage, setShowMessage] = useState(true);
    if (!showMessage) {
        return null;
    }
    return (_jsx("div", Object.assign({ id: 'application-messages-container', className: `page-message ${isSuccessful ? 'success' : 'error'}` }, { children: _jsxs("div", Object.assign({ className: 'row' }, { children: [_jsx("button", Object.assign({ type: 'button', className: 'close', onClick: handleClickClose }, { children: _jsx("svg", Object.assign({ className: 'svg-icon' }, { children: _jsx("use", { xlinkHref: '/assets/SVGSpriteSheet.svg#close' }) })) })), _jsx("div", Object.assign({ className: 'columns small-12' }, { children: _jsx("h4", { children: message }) }))] })) })));
    function handleClickClose() {
        setShowMessage(false);
        if (typeof onClose === 'function') {
            onClose();
        }
    }
}
ComponentMessage.propTypes = {
    message: PropTypes.string.isRequired,
    isSuccessful: PropTypes.bool,
    onClose: PropTypes.func
};
export default ComponentMessage;
